import React from 'react'
import { useMemo } from 'react'

import Stack from '@mui/material/Stack'
import { useSelector } from 'react-redux'

import {
  addOpportunityMarketingAttributionSection,
  entityCampaignId,
  entityLeadSourceId,
  entityReferral,
} from '@user/components/Settings/EntityFormSettings'
import { Referral } from '../../FormComponents/Referral/Referral'
import { FormSectionTitle } from '../../FormComponents/FormSectionTitle'
import CampaignSelect from '../../FormComponents/CampaignSelect/CampaignSelect'
import { LeadSourceSelect } from '../../FormComponents/LeadSourceSelect/LeadSourceSelect'

import {
  IEntityFormSetting,
  selectAllEntityFormSettings,
} from '@user/store/entityFormSettings'
import { useGetFieldActiveStates } from '@user/store/entityFormSettings/hooks/useGetFieldActiveStates'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'
import { DensityType } from '../../../typings'

type Props = {
  hideOptional: boolean
}

export function MarketingAttributionSection(props: Props) {
  const { hideOptional } = props
  const tidalThemeActive = useTidalThemeActive()

  const settings: IEntityFormSetting[] = useSelector(
    selectAllEntityFormSettings,
  )
  const entitySettingsMap = useGetFieldActiveStates(settings, hideOptional)

  const [requiredLeadSourceId, showLeadSource] = entitySettingsMap.get(
    entityLeadSourceId,
  ) ?? [false, true]
  const [requiredCampaignId, showCampaign] = entitySettingsMap.get(
    entityCampaignId,
  ) ?? [false, true]

  const [requiredReferral, showReferral] = entitySettingsMap.get(
    entityReferral,
  ) ?? [false, true]

  const showSection: boolean = useMemo(
    () =>
      !!settings.find(
        (setting) =>
          setting.sectionId === addOpportunityMarketingAttributionSection &&
          (setting.required || (setting.active && !hideOptional)),
      ),
    [hideOptional, settings],
  )

  const density: DensityType = tidalThemeActive ? 'normal' : 'compact'

  return showSection ? (
    <Stack gap={2} pb={4}>
      <FormSectionTitle>Marketing Attribution</FormSectionTitle>
      <CampaignSelect
        density={density}
        name="campaignId"
        required={requiredCampaignId}
        leadSourceRequired={requiredLeadSourceId}
        show={showCampaign}
      />
      <LeadSourceSelect
        density={density}
        name="leadSourceId"
        required={requiredLeadSourceId}
        show={showLeadSource}
      />
      <Referral
        name="referral"
        required={requiredReferral}
        show={showReferral}
      />
    </Stack>
  ) : null
}
